import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import PartnerSearch from './PartnerSearch'
import { selectIsTablet } from '../../../layout/state/selector'
import { selectIsPartner } from '../../../security/state/auth/selector'

const mapStateToProps = state => {
    return {
        tableData: selector.tableSelectorPartner(state),
        isTablet: selectIsTablet(state),
        isPartner: selectIsPartner(state),
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryPartner,
    initialTableSettings: action.initialTableSettings,
    toggleColumnVisibility: action.toggleColumnVisibility,
    changeFilter: action.changeFilterPartner,
    toggleSort: action.toggleSortPartner,
    toggleMultiSort: action.toggleMultiSortPartner,
    gotoPage: action.gotoPagePartner,
    navigateToPartner: (partnerId) => {
        return push('/partner/edit/' + partnerId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(PartnerSearch)



// WEBPACK FOOTER //
// ./src/modules/partner/component/search/PartnerSearchContainer.js